import React, { useState, useEffect } from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import ReactRouterPropTypes from 'react-router-prop-types';
import { showNotificationAutoDestroy } from '../../../shared/components/ShowNotification';
import {
  changeLoadingTrue,
  changeLoadingFalse,
} from '../../../redux/actions/loadingActions';
import GraphQL from '../../../GraphQL';
import ContractTypesForm from './Form';
import SmartCard from '../../../shared/components/SmartCard';
import {
  contractSignatoryAvailableList,
  contractTypeListByFilter,
  contractTypeSaveMutation,
} from '../../../shared/queries/ContractTypes';
import { upLoadFilePromise } from '../../../shared/utils/smartutils';
import { APPLICATION_PDF, PAGE_TYPE } from '../../../shared/utils/constants';

const ContractTypesFormHandler = (props) => {
  const { match, t, history, dispatch } = props;
  const [dto, setDto] = useState({});
  const [formOn, setFormOn] = useState(false);
  const [signatories, setSignatories] = useState([]);

  const backClickHandler = () => {
    history.push('/minime/tipo-contrato');
  };

  const showLoading = () => {
    dispatch(changeLoadingTrue());
  };

  const hideLoading = () => {
    dispatch(changeLoadingFalse());
  };

  const loadAllSignatory = (id) => {
    const query = contractSignatoryAvailableList(id);
    showLoading();
    GraphQL(query, {})
      .then((res) => {
        hideLoading();
        if (res.contractSignatoryAvailableList) {
          res.contractSignatoryAvailableList =
            res.contractSignatoryAvailableList.map((item) => ({
              ...item,
              id: item.id,
              value: item.id,
              label: t(`${item.name}`),
            }));
          setSignatories(res.contractSignatoryAvailableList);
        } else {
          showNotificationAutoDestroy(
            'danger',
            t('notifications.error'),
            t('notifications.record-not-found')
          );
          backClickHandler();
        }
      })
      .catch(() => {
        hideLoading();
        showNotificationAutoDestroy(
          'danger',
          t('errors.title'),
          t('errors.error-to-loading')
        );
      });
  };

  const findById = (id) => {
    showLoading();
    const query = contractTypeListByFilter(id);
    GraphQL(query, {})
      .then((res) => {
        hideLoading();
        if (res.contractTypeListByFilter) {
          const listOfPages = res.contractTypeListByFilter[0].listOfPages.map(
            (item) => ({
              ...item,
              fileId: item.id,
              preview: item.fileUrl || '',
              type: APPLICATION_PDF,
              notExclude: item.pageType === PAGE_TYPE.C,
            })
          );
          setDto({
            ...res.contractTypeListByFilter[0],
            listOfPages,
          });
        } else {
          showNotificationAutoDestroy(
            'danger',
            t('notifications.error'),
            t('notifications.record-not-found')
          );
          backClickHandler();
        }
      })
      .catch(() => {
        hideLoading();
        showNotificationAutoDestroy(
          'danger',
          t('errors.title'),
          t('errors.error-to-loading')
        );
      });
  };

  const saveContractType = (values, uploadedFiles, filesAlreadyUploaded) => {
    const mutation = contractTypeSaveMutation(
      values,
      uploadedFiles,
      filesAlreadyUploaded
    );
    hideLoading();
    showLoading();
    GraphQL(mutation, {})
      .then(() => {
        hideLoading();
        backClickHandler();
        showNotificationAutoDestroy(
          'success',
          t('success.title'),
          t('success.successfully-saved')
        );
      })
      .catch(() => {
        hideLoading();
        showNotificationAutoDestroy(
          'danger',
          t('errors.title'),
          t('errors.error-to-loading')
        );
      });
  };

  const handleSubmit = async (values) => {
    showLoading();
    const { listOfPages } = values;
    if (listOfPages.length > 0) {
      const filesAlreadyUploaded = listOfPages.filter(
        (file) => typeof file.id === 'number'
      );
      const filesTopload = listOfPages.filter(
        (file) => typeof file.id !== 'number'
      );
      const arrPromises = await filesTopload.map((file) =>
        upLoadFilePromise(file).then(({ data }) => ({ ...file, ...data }))
      );
      await Promise.all(arrPromises)
        .then((uploadedFiles) => {
          saveContractType(values, uploadedFiles, filesAlreadyUploaded);
        })
        .catch((error) => {
          hideLoading();
          if (error.response) {
            showNotificationAutoDestroy(
              'danger',
              t('notifications.attention'),
              t('notifications.upload-error')
            );
          }
        });
    }
  };

  useEffect(() => {
    if (match.params.id && match.params.id > 0) {
      if (dto.id !== parseInt(match.params.id, 0)) {
        findById(match.params.id);
        loadAllSignatory(match.params.id);
      } else {
        setFormOn(true);
      }
    } else {
      setFormOn(true);
    }
  }, [dto]);

  useEffect(() => {
    if (match.params) {
      loadAllSignatory(match.params.id);
    } else {
      loadAllSignatory(0);
    }
    setDto({ id: 0, active: true, listOfSignatory: [] });
  }, []);

  return (
    <SmartCard title={t('screens.mnt_tipo_contratos.title')}>
      {formOn && (
        <ContractTypesForm
          onSubmit={handleSubmit}
          backHandler={backClickHandler}
          dto={dto}
          signatories={signatories}
        />
      )}
    </SmartCard>
  );
};

ContractTypesFormHandler.propTypes = {
  t: PropTypes.func.isRequired,
  dispatch: PropTypes.func.isRequired,
  history: ReactRouterPropTypes.history.isRequired,
  match: ReactRouterPropTypes.match.isRequired,
};

export default withTranslation('common')(
  connect((state) => ({
    loading: state.loading,
  }))(ContractTypesFormHandler)
);
